<template>
  <div class="container-fluid py-4">

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-hospital fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Hospitalisations</h2>
      </div>
      <button hidden
        class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0"
        @click="creation"
        v-if="$store.getters.hasPermission('HOSPITALISATION_CREATE')"
      >
        <i class="bi bi-plus-circle me-1"></i> 
      </button>
    </div>

    <!-- Filtres -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Patient, chambre, lit..."
            class="form-control form-control-clinique"
          />
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;"></div>
      <p class="mt-3">Chargement des hospitalisations...</p>
    </div>

    <!-- Tableau -->
    <div v-else class="card shadow-sm rounded card-clinique">
      <div class="table-responsive overflow-auto">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique w-100">
          <thead>
            <tr>
              <th>#</th>
              <th>Date entrée</th>
              <th>Patient</th>
              <th class="d-none d-sm-table-cell">Chambre</th>
              <th class="d-none d-sm-table-cell">Type</th>
              <th class="d-none d-sm-table-cell">Lit</th>
              <th>Date sortie prévue</th>
              <!--<th class="d-none d-md-table-cell">Montant Facture</th>-->
              <th class="d-none d-md-table-cell">Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(hos, index) in filteredHospitalisations" :key="hos.id" :class="{ 'ligne-aujourdhui': isSortieAujourdhui(hos) }">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ formatDate(hos.dateEntree) }}</td>
              <td>{{ hos.patient_nom }} {{ hos.patient_prenom }}</td>
              <td class="d-none d-sm-table-cell">{{ hos.chambre_numero || '—' }}</td>
              <td class="d-none d-sm-table-cell">{{ hos.chambre_type_nom || '—' }}</td>
              <td class="d-none d-sm-table-cell">{{ hos.lit_numero || '—' }}</td>
              <td :class="getColorClasse(hos)">{{ formatDate(hos.dateSortiePrevue) }}</td>
              <!--<td class="d-none d-md-table-cell">{{ hos.montantFacture ? hos.montantFacture + ' FCFA' : '—' }}</td>-->
              <td class="d-none d-md-table-cell fw-semibold">{{ hos.statut || '—' }}</td>
              <td>
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-outline-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="$store.getters.hasPermission('HOSPITALISATION_EDIT') && hos.statut !== 'Clôturée'" hidden>
                      <a class="dropdown-item" @click="modifier(hos.id)">Modifier</a>
                    </li>
                    <li>
                      <a class="dropdown-item" @click="details(hos)">
                        Détails
                      </a>
                    </li>
  
                   



                    <li v-if="$store.getters.hasPermission('HOSPITALISATION_DELETE')">
                      <a class="dropdown-item text-danger" @click="supprimer(hos.id)">Supprimer</a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="hospitalisations.length === 0">
              <td colspan="10" class="text-center py-3">Aucune hospitalisation disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end p-3">
        <ul class="pagination pagination-modern flex-wrap mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      isLoading: true,
      isFirstLoad: true,
      searchQuery: '',
      itemsperpage: 40,
      orderBy: 'hos.dateEntree',
      sortOrder: 'desc',
      hospitalisations: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [40, 80, 120],
      orderByTabs: {
        "Date d'entrée": "hos.dateEntree",
        "Montant": "hos.montantFacture",
        "Statut": "hos.statut"
      },
      sortOrders: { Croissant: 'asc', Décroissant: 'desc' }
    };
  },
  computed: {
    filteredHospitalisations() {
      if (!this.searchQuery) return this.hospitalisations;
      const q = this.searchQuery.toLowerCase();
      return this.hospitalisations.filter(h =>
        (h.patient_nom?.toLowerCase().includes(q)) ||
        (h.patient_prenom?.toLowerCase().includes(q)) ||
        (h.chambre_numero?.toLowerCase().includes(q)) ||
        (h.lit_numero?.toLowerCase().includes(q)) ||
        (h.statut?.toLowerCase().includes(q)) ||
        dayjs(h.dateEntree).format('DD-MM-YYYY HH:mm').includes(q) ||
        dayjs(h.dateSortiePrevue).format('DD-MM-YYYY HH:mm').includes(q) ||
        (h.numHospitalisation?.toLowerCase().includes(q))
      );
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    }
  },
  methods: {
    formatDate(date) {
      return date ? dayjs(date).format('DD-MM-YYYY') : '—';
    },
    creation() {
      this.$router.push({ name: 'create_hospitalisation' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_hospitalisation', params: { id } });
    },
    async getHospitalisations() {
      if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      }
      try {
        const res = await api.getItems('hospitalisations', {
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          itemsperpage: this.itemsperpage,
          page: this.currentPage,
          search: this.searchQuery
        });
        const { data, meta } = res.data;
        this.hospitalisations = data;
        this.totalItems = meta?.total_records ?? data.length;
      } catch (err) {
        console.error('Erreur chargement hospitalisations:', err);
      } finally {
        this.isLoading = false;
      }
    },
   isSortieAujourdhui(hos) {
  if (!hos.dateSortiePrevue) return false;

  const today = dayjs().startOf('day');
  const sortie = dayjs(hos.dateSortiePrevue).startOf('day');
  return sortie.isSame(today);
},
    async supprimer(id) {
      if (!window.confirm("Voulez-vous vraiment supprimer cette hospitalisation ?")) return;
      try {
        await api.deleteItem('hospitalisations', id);
        this.getHospitalisations();
      } catch {
        alert("Erreur lors de la suppression.");
      }
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.getHospitalisations();
      }
    },
    details(hos) {
     return this.$router.push({name: 'details_hospitalisation', params: {id: hos.id}})
    },
    getColorClasse(hosp) {
      const aujourdHui = dayjs().startOf("day");
      const sortie = hosp.dateSortiePrevue ? dayjs(hosp.dateSortiePrevue).startOf("day") : null;
      
      
      if (hosp.statut === "En cours" && sortie) {
        if (sortie.isBefore(aujourdHui)) return "text-danger fw-bold"; // Dépassée
        return "text-success fw-bold"; // Valide
      }
      if (hosp.statut === "Clôturée") {
        if (hosp.estPaye === "Payée") return "text-primary fw-bold";
        return "text-warning fw-bold";
      }
      return "";
    }
  },
  watch: {
    searchQuery() { this.currentPage = 1; this.getHospitalisations(); },
    itemsperpage() { this.currentPage = 1; this.getHospitalisations(); },
    orderBy() { this.getHospitalisations(); },
    sortOrder() { this.getHospitalisations(); }
  },
  created() {
    this.getHospitalisations();
  },
  async imprimerHospitalisation(hos) {
  // Charger les infos système
  if (!this.systeme) {
    const res = await api.getItems('configurations');
    this.systeme = res.data.data[0] || {};
  }

  // Préparer données
  const config = this.systeme || {};
  const patient = {
    nom: hos.patient_nom,
    prenom: hos.patient_prenom
  };

  const baseURL = process.env.VUE_APP_API_BASE_URL || "";
  const logoUrl = config.logo
    ? (config.logo.startsWith("http") ? config.logo : `${baseURL}${config.logo}`)
    : "";

  const reference = `HOS-${hos.id}-${new Date().getFullYear()}`;
  const dateEntree = this.formatDate(hos.dateEntree);
  const dateSortiePrevue = this.formatDate(hos.dateSortiePrevue);
  const dateSortieReelle = this.formatDate(hos.dateSortieReelle);

  const printWindow = window.open("", "_blank");

  const htmlContent = `
    <html>
      <head>
        <title>Reçu d’Hospitalisation</title>
        <style>
          @page {
            size: A4;
            margin: 2cm;
          }

          body {
            font-family: "Times New Roman", serif;
            color: #000;
            font-size: 14px;
            line-height: 1.6;
            margin: 0;
            padding: 0;
          }

          /* ✅ Header fixe */
          header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: 120px;
            display: flex;
            justify-content: space-between;
            border-bottom: 2px solid #0056b3;
            padding: 10px 2cm;
          }

          header img {
            width: 80px;
            height: 80px;
            object-fit: contain;
          }

          /* ✅ Footer fixe */
          footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 80px;
            border-top: 2px solid #0056b3;
            padding: 10px 2cm;
            display: flex;
            justify-content: space-between;
          }

          /* ✅ Contenu entre header/footer */
          .content {
            margin-top: 150px;
            margin-bottom: 100px;
            padding: 0 1cm;
          }

          h3 {
            text-align: center;
            text-decoration: underline;
            color: #0056b3;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 15px;
          }
          th, td {
            border: 1px solid #0056b3;
            padding: 8px;
          }
          th {
            background: #e6f0ff;
          }

          @media print {
            header, footer { position: fixed; }
          }
        </style>
      </head>

      <body>

        <!-- ✅ Header -->
        <header>
          <div style="display:flex; align-items:center;">
            ${logoUrl ? `<img src="${logoUrl}" alt="Logo">` : ""}
            <div style="margin-left:10px;">
              <h2 style="margin:0;color:#0056b3;">${config.nom || "Clinique Médicale"}</h2>
              <p>${config.adresse || ""}</p>
              <p>Tél : ${config.telephone || ""}</p>
            </div>
          </div>

          <div style="text-align:right;">
            <p><strong>Réf :</strong> ${reference}</p>
            <p><strong>Date :</strong> ${dateEntree}</p>
          </div>
        </header>

        <!-- ✅ Contenu -->
        <div class="content">

          <h3>REÇU D’HOSPITALISATION</h3>

          <p><strong>Patient :</strong> ${patient.nom} ${patient.prenom}</p>
          <p><strong>Chambre :</strong> ${hos.chambre_numero || "—"} / 
             <strong>Lit :</strong> ${hos.lit_numero || "—"}</p>

          <p>
            <strong>Montant :</strong> ${hos.montantFacture?.toLocaleString() || "0"} FCFA &nbsp;&nbsp;
            <strong>Statut :</strong> ${hos.statut}
          </p>

          <table>
            <tr>
              <th>Date entrée</th>
              <td>${dateEntree}</td>
            </tr>
            <tr>
              <th>Date sortie prévue</th>
              <td>${dateSortiePrevue}</td>
            </tr>
            <tr>
              <th>Date sortie réelle</th>
              <td>${dateSortieReelle}</td>
            </tr>
          </table>

        </div>

        <!-- ✅ Footer -->
        <footer>
          <div>Bamako, le ${new Date().toLocaleDateString()}</div>
          <div><strong>Signature & Cachet</strong></div>
        </footer>

      </body>
    </html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.print();
    printWindow.close();
  };
}

};

</script>

<style scoped>
/* mêmes styles que la page patients pour cohérence */
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}
.form-control-clinique,
.form-select-clinique {
  border-radius: 8px;
  box-shadow: none;
}
.modern-table-clinique th {
  background: #eef5ff;
  font-weight: 600;
}
.pagination-modern .page-link {
  border-radius: 6px;
  margin: 0 2px;
}

/* Responsive */
@media (max-width: 767px) {
  .header-clinique {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .btn-clinique {
    width: 100%;
  }
  table th, table td {
    white-space: nowrap;
  }
}

/* Couleurs de statut */
.text-danger { color: #dc3545 !important; }
.text-success { color: #198754 !important; }
.text-primary { color: #0d6efd !important; }
.text-warning { color: #fd7e14 !important; }
.ligne-aujourdhui {
  background-color: #d1e7dd; /* vert clair */
  font-weight: 600;
}

</style>
